import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { IPageDidUnmountHandler } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { ScrollRestorationAPISymbol, name } from './symbols'
import type { IScrollRestorationAPI, ScrollRestorationPageConfig } from './types'

const scrollRestorationFactory = (
	{ shouldRestoreScrollPosition }: ScrollRestorationPageConfig,
	scrollRestorationAPI: IScrollRestorationAPI
): IPageDidUnmountHandler => {
	return {
		pageDidUnmount() {
			if (shouldRestoreScrollPosition) {
				const scrollY = scrollRestorationAPI.getScrollYHistoryState()
				if (scrollY) {
					scrollRestorationAPI.restoreScrollPosition()
				} else {
					scrollRestorationAPI.scrollToTop()
				}
			}
		},
	}
}

export const ScrollRestoration = withDependencies(
	[named(PageFeatureConfigSymbol, name), ScrollRestorationAPISymbol],
	scrollRestorationFactory
)
